/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SafeSize = {
    CashPayment: 'CASH_PAYMENT',
    Various: 'VARIOUS',
    Cabin1: 'CABIN_1',
    Cabin2: 'CABIN_2',
    SpecialSize1: 'SPECIAL_SIZE_1',
    No: 'NO',
    DormantSafeDepositBox: 'DORMANT_SAFE_DEPOSIT_BOX',
    Size1: 'SIZE_1',
    Size2: 'SIZE_2',
    Size3: 'SIZE_3',
    Size4: 'SIZE_4',
    Size5: 'SIZE_5'
} as const;
export type SafeSize = typeof SafeSize[keyof typeof SafeSize];


export function instanceOfSafeSize(value: any): boolean {
    for (const key in SafeSize) {
        if (Object.prototype.hasOwnProperty.call(SafeSize, key)) {
            if (SafeSize[key as keyof typeof SafeSize] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SafeSizeFromJSON(json: any): SafeSize {
    return SafeSizeFromJSONTyped(json, false);
}

export function SafeSizeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SafeSize {
    return json as SafeSize;
}

export function SafeSizeToJSON(value?: SafeSize | null): any {
    return value as any;
}

export function SafeSizeToJSONTyped(value: any, ignoreDiscriminator: boolean): SafeSize {
    return value as SafeSize;
}

